import { css } from "@emotion/react";
import { fonts } from "./fonts.js";

export const getGlobalStyles = (theme) => {
    return css`
        ${fonts};
        :root {
            --nvidia-global-font: NVIDIA;
            --nvidia-nala-font: NVIDIA-NALA;
            --nvidia-emea-font: NVIDIA-EMEA;
            --nvidia-ru-font: NVIDIA-RU;
            --nvidia-apac-font: NVIDIA-APAC;
            --nvidia-cn-font: NVIDIA-CN;
            --font-fallback: Arial, Helvetica, Sans-Serif;
            --jp-fallback-font: "source-han-sans-japanese ";
            --kr-fallback-font: "source-han-sans-korean";
            --tw-fallback-font: "source-han-sans-traditional";
            --cn-fallback-font: "source-han-sans-simplified-c";
        }

        *,
        *:before,
        *:after {
            box-sizing: border-box;
        }

        #root {
            margin-top: 60px;
        }

        #root > div {
            overflow-y: visible;
        }

        #footer-container {
            width: 100%;
        }

        #account-home-root > div {
            min-height: calc(100vh - 264px);
        }

        #content {
            width: 100%;
            flex-grow: 1;
        }

        .logo {
            margin-right: 30px;
            svg {
                width: 110px;
                height: 20px;
            }
        }

        body {
            font-family: var(--nvidia-global-font), var(--font-fallback);
            overflow-x: hidden;
            display: flex;
            align-items: center;
            justify-content: space-between;
            min-height: 100vh;
            flex-direction: column;
            margin: 0;
            padding: 0;
            background-color: ${theme === "dark" ? "#111" : "#fefefe"};
            padding-top: 110px;
            @media screen and (max-width: 1025px) {
                padding-top: 90px;
            }
        }

        :lang(en-us),
        :lang(en-zz),
        :lang(en-gb),
        :lang(en-sg),
        :lang(en-au),
        :lang(en-eu),
        :lang(en-in),
        :lang(en-il),
        :lang(es-la),
        :lang(es-uy),
        :lang(es-cl),
        :lang(es-py),
        :lang(es-ar),
        :lang(pt-br) * {
            font-family: var(--nvidia-nala-font), var(--font-fallback);
        }
        :lang(de-at),
        :lang(fr-be),
        :lang(cs-cz),
        :lang(da-dk),
        :lang(nl-nl),
        :lang(nb-no),
        :lang(pl-pl),
        :lang(pt-pt),
        :lang(ro-ro),
        :lang(es-es),
        :lang(sv-se),
        :lang(de-ch),
        :lang(tr-tr),
        :lang(de-de),
        :lang(fr-fr),
        :lang(fi-fi),
        :lang(it-it),
        :lang(hu-hu),
        :lang(sl-si),
        :lang(sk-sk) * {
            font-family: var(--nvidia-emea-font), var(--font-fallback);
        }
        :lang(ru-ru) * {
            font-family: var(--nvidia-ru-font), var(--font-fallback);
        }
        :lang(ja-jp) * {
            font-family: var(--nvidia-apac-font), var(--jp-fallback-font), var(--font-fallback);
        }
        :lang(ko-kr) * {
            font-family: var(--nvidia-apac-font), var(--kr-fallback-font), var(--font-fallback);
        }
        :lang(zh-tw) * {
            font-family: var(--nvidia-apac-font), var(--tw-fallback-font), var(--font-fallback);
        }
        :lang(zh-cn) * {
            font-family: var(--nvidia-cn-font), var(--cn-fallback-font), var(--font-fallback);
        }
        :lang(vi-vn) * {
            font-family: var(--nvidia-apac-font), var(--font-fallback);
        }
    `;
};
